import { Grid } from "@mui/material";
import { FC, useCallback, useState } from "react";
import { MfaWay, UserResponseDto } from "@/gen/api/user";
import { MutationCallbacks, SaveAction } from "@/dataProvider/types";
import { FormValues, ProfileUpdateForm } from "@/components/profile/ProfileUpdateForm";
import { OdResourcePageProps } from "@/types/resource";
import { Content } from "@/components/content/Content";
import ProfileAvatar from "@/components/profile/ProfileAvatar";
import { useIsSecureFileOnly } from "@/authProvider/useIsSecureFileOnly";
import { useIsLocalUserWithNoPhone } from "@/authProvider/useIsLocalUserWithNoPhone";


export interface ProfileFormValues {
  firstName: string;
  lastName: string;
  phone: string;
  mfaWay: MfaWay;
  avatarFile: File;
}

export type ProfileUpdateBodyProps = {
  save: SaveAction<ProfileFormValues>;
  user: UserResponseDto | undefined;
  idTokenUser: any;
}

const ProfileUpdateBody: FC<OdResourcePageProps & ProfileUpdateBodyProps> = (props) => {
  const { 
    save,
    options,
    user,
    idTokenUser,
  } = props

  const [avatarFile, setAvatarFile] = useState<File | undefined>()
  const isSecureFileOnly = useIsSecureFileOnly()
  const isLocalUserWithNoPhone = useIsLocalUserWithNoPhone()
  
  const finalSave = useCallback(function(values: Partial<FormValues>, redirect, options: MutationCallbacks = {}) {
    const profile: Partial<UserResponseDto> = { ...values }
    const extend = {
      avatarFile: avatarFile,
    }

    if (save) {
      //@ts-ignore
      save({ ...profile, ...extend }, '', options)
    }
  }, [avatarFile, save])

  return (
    <Content pageName={"My Account"} resourceName="My Account" breadcrumbs={(isSecureFileOnly || isLocalUserWithNoPhone) ? undefined : options?.breadcrumbs}>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={4}
          md={6}
          xl={3}
          xs={12}
        >
          <ProfileAvatar 
            prevAvatarUrl={user?.avatarUrl}
            username={user?.username}
            setAvatarFile={setAvatarFile}
          />
        </Grid>
        <Grid
          item
          lg={8}
          md={6}
          xl={9}
          xs={12}
        >
          <ProfileUpdateForm 
            save={finalSave}
            idTokenUser={idTokenUser}
            user={user}
          />
        </Grid>
      </Grid>
  
    </Content>                  
  )
}

export default ProfileUpdateBody;
